import { createTheme } from "@mui/material/styles";

const primaryMain = "#10a396";
const secondaryMain = "#f27435";
export const colors = {
  navy: "#0c1528",
  navyLight: "#141f38",
  slate: "#f4f6f9",
  slateBorder: "#e2e8f0",
};

const theme = createTheme({
  palette: {
    primary: {
      main: primaryMain,
      dark: "#0d8a80",
      light: "#e0f5f3",
      contrastText: "#ffffff",
    },
    secondary: {
      main: secondaryMain,
      dark: "#d45a22",
      light: "#fff0e8",
      contrastText: "#ffffff",
    },
    text: {
      primary: "#0c1528",
      secondary: "#5c6370",
    },
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
    divider: "#e2e8f0",
  },
  typography: {
    fontFamily: '"DM Sans", "Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, sans-serif',
    h1: { fontWeight: 700, letterSpacing: "-0.02em" },
    h2: { fontWeight: 700, letterSpacing: "-0.02em" },
    h3: { fontWeight: 600, letterSpacing: "-0.01em" },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "12px 28px",
          boxShadow: "none",
          fontSize: "0.95rem",
          "&:hover": { boxShadow: "none" },
        },
        containedPrimary: {
          "&:hover": { backgroundColor: "#0d8a80" },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: "1px solid #e8ecef",
          boxShadow: "0 4px 24px rgba(27, 29, 33, 0.06)",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: { boxShadow: "none" },
      },
    },
  },
});

export default theme;
